<template>

    <div class="row" v-if="visitasinterpwgs">
        <div class="col-md-12">
            <div class="card" >
                <div class="card-header bg-gray">
                    <h3 class="card-title"><i class="fas fa-list mr-2"></i>InterPWGS</h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body" >
                   <table class="table">

                        <thead>

                            <tr>
                                <th style="text-align:center">
                                    Fecha
                                </th>

                                <th style="text-align:center">
                                    En domicilio
                                </th>

                                <th style="text-align:center">
                                    Fotos
                                </th>

                                <th style="text-align:center">
                                    Trabajos realizados/pendientes
                                </th>

                                <th style="text-align:center">
                                    Firma
                                </th>

                                <th style="text-align:center">
                                    Finalización
                                </th>

                                <th></th>
                            </tr>

                        </thead>

                        <tbody>

                            <tr v-for="visita in visitasUnicas" :key="visita.id_comunicacion">

                                <!-- FECHA -->
                                <td
                                    class="col-fecha"
                                    style="text-align:center"
                                >

                                    <span
                                        v-if="visita.anulada == 1"
                                        style="color:red"
                                    >
                                        ANULADA
                                    </span>

                                    <br>

                                    <b v-if="visita.hora_visita">
                                        {{ visita.especialidad }}
                                    </b>

                                    <br>

                                    <span v-if="visita.hora_visita">

                                        {{
                                            new Date(
                                                visita.fecha_visita
                                            ).toLocaleDateString("es-ES")
                                        }}

                                        <br>

                                        {{ visita.hora_visita }}

                                    </span>
                                    <span v-if="visita.fecha_cita_companyia" style="color:#a67d02">
                                        <br>
                                        <small>La compañía pidió: {{ visita.fecha_cita_companyia }}</small>
                                    </span>
                                </td>

                                <!-- EN DOMICILIO -->
                                <td
                                    class="col-checkbox"
                                    v-if="visita.anulada != 1"
                                >

                                    <input
                                        type="checkbox"
                                        v-if="
                                            !visita.finalizacion &&
                                            !visita.en_domicilio
                                        "
                                        value="1"
                                        checked
                                        disabled
                                    />

                                    <span
                                        v-if="visita.en_domicilio == 1"
                                    >
                                        Si
                                    </span>

                                    <span
                                        v-if="
                                            visita.finalizacion == 1 &&
                                            visita.en_domicilio != 1
                                        "
                                    >
                                        No
                                    </span>

                                </td>

                                <td v-if="visita.anulada == 1"></td>

                                <!-- FOTOS -->
                                <td class="col-fotos">

                                    <div class="mb-2" v-if="hayDocumentosSeleccionables(visita)" > <button type="button" class="btn btn-sm btn-primary mr-2" @click=" toggleTodosDocumentos(visita) " > {{ todosDocumentosSeleccionados( visita ) ? 'Seleccionar ninguna' : 'Seleccionar todas' }} </button> </div>
                                    <div class="contenedor-imagenes">

                                        <div
                                            class="doc-item"
                                            v-for="
                                                documento
                                                in visita.documentos_disponibles
                                            "
                                            :key="documento.id_documento"
                                        >

                                            <!-- MINIATURA -->
                                            <div class="img-wrapper">

                                                <img class="miniatura" :src="getUrl(documento)" :alt="documento.descripcion" />

                                                <!-- PREVIEW -->
                                                <div class="preview">

                                                    <img :src="getUrl(documento)"/>

                                                </div>

                                            </div>

                                            <span
                                                v-if="documento.cuando"
                                                class="badge badge-primary"
                                            >
                                                {{ documento.cuando }}
                                            </span>

                                            <br>

                                            <!-- CHECK -->
                                            <label
                                                class="check-doc"
                                                v-if="
                                                    !estaEnviado(
                                                        visita,
                                                        documento.id_documento
                                                    )
                                                "
                                            >

                                                <input
                                                    type="checkbox"
                                                    :value="
                                                        documento.id_documento
                                                    "
                                                    v-model="
                                                        documentosSeleccionados[
                                                            'fotos_interpwgs' +
                                                            visita
                                                                .id_comunicacion
                                                        ]
                                                    "
                                                />

                                                <input
                                                    type="text"
                                                    class="form-control mt-1"
                                                    placeholder="Descripción"
                                                    v-model="
                                                        descripcionDocumentos[
                                                            documento
                                                                .id_documento
                                                        ]
                                                    "
                                                />

                                            </label>

                                            <!-- YA ENVIADO -->
                                            <label
                                                v-if="
                                                    estaEnviado(
                                                        visita,
                                                        documento.id_documento
                                                    ) &&
                                                    visita
                                                        .documentos_enviados_descripcion
                                                "
                                            >

                                                {{
                                                    visita
                                                        .documentos_enviados_descripcion[
                                                        documento.id_documento
                                                    ]
                                                }}

                                            </label>

                                        </div>

                                    </div>

                                </td>

                                <!-- ANULADA -->
                                <td
                                    v-if="visita.anulada == 1"
                                    style="text-align:center"
                                >
                                    Visita anulada.
                                </td>

                                <!-- SIN HORA -->
                                <td
                                    v-if="!visita.hora_visita"
                                    style="text-align:center"
                                >

                                    <span
                                        v-if="visita.anulada != 1"
                                    >

                                        Para el envío de datos,
                                        crea una visita desde el formulario
                                        de visita que aparece en el planning.

                                    </span>

                                </td>

                                <!-- TRABAJOS -->
                                <td
                                    style="text-align:center"
                                    v-if="
                                        visita.anulada != 1 &&
                                        visita.hora_visita
                                    "
                                >

                                    <textarea
                                        v-if="
                                            visita.finalizacion != 1
                                        "
                                        v-model="
                                            visita
                                                .trabajos_realizados_enviar
                                        "
                                        class="form-control"
                                    ></textarea>

                                    <span
                                        v-if="
                                            visita.finalizacion == 1
                                        "
                                    >

                                        <small>
                                            {{
                                                visita
                                                    .trabajos_realizados_enviar
                                            }}
                                        </small>

                                        <br>

                                    </span>

                                    <textarea
                                        v-if="
                                            visita.finalizacion != 1
                                        "
                                        v-model="
                                            visita
                                                .trabajos_pendientes_enviar
                                        "
                                        class="form-control"
                                    ></textarea>

                                    <span
                                        style="text-align:center"
                                        v-if="
                                            visita.finalizacion == 1
                                        "
                                    >

                                        <small>
                                            {{
                                                visita
                                                    .trabajos_pendientes_enviar
                                            }}
                                        </small>

                                    </span>

                                </td>

                                <!-- FIRMA -->
                                <td
                                    class="col-checkbox"
                                    v-if="visita.anulada != 1"
                                >

                                    <span
                                        v-if="
                                            visita.firmada_visita == 0
                                        "
                                    >
                                        Sin firma
                                    </span>

                                    <span
                                        v-if="
                                            visita.firmada_visita == 1 &&
                                            visita.finalizacion == 1 &&
                                            visita.firma != 1
                                        "
                                    >
                                        Firma NO enviada
                                    </span>

                                    <input
                                        v-if="
                                            visita.finalizacion != 1 &&
                                            visita.firmada_visita == 1 &&
                                            visita.firma != 1
                                        "
                                        type="checkbox"
                                        v-model="
                                            visita.enviarfirma
                                        "
                                        :true-value="1"
                                        :false-value="0"
                                    >

                                    <span
                                        v-if="
                                            visita.firmada_visita == 1 &&
                                            visita.firma == 1
                                        "
                                    >
                                        Firma enviada
                                    </span>

                                </td>

                                <!-- FINALIZACION -->
                                <td
                                    class="col-checkbox"
                                    v-if="
                                        visita.anulada != 1 &&
                                        visita.hora_visita
                                    "
                                >

                                    <input
                                        v-if="
                                            visita.finalizacion != 1
                                        "
                                        type="checkbox"
                                        v-model="
                                            visita.enviarfinalizacion
                                        "
                                        :true-value="1"
                                        :false-value="0"
                                    >

                                    <span
                                        v-if="
                                            visita.finalizacion == 1
                                        "
                                    >
                                        Finalizada
                                    </span>

                                </td>

                                <!-- ENVIAR -->
                                <td
                                    class="col-fecha"
                                    v-if="
                                        visita.anulada != 1 &&
                                        visita.hora_visita
                                    "
                                >

                                    <Button
                                        v-if="
                                            visita.finalizacion != 1
                                        "
                                        class="btn btn-primary"
                                        label="Enviar"
                                        @click="
                                            enviarinformacionvisita(
                                                visita
                                            )
                                        "
                                    />

                                    <span
                                        v-if="
                                            visita.finalizacion == 1
                                        "
                                    >
                                        Enviado
                                    </span>

                                </td>

                            </tr>

                        </tbody>

                    </table> 
                </div>
            </div>
        </div>
    </div>
    <div class="row"  style="margin-bottom:10px" v-if="servicio?.compania?.sistema == 'MULTIASISTENCIA_WS'">
        <div class="col-md-6">
            <label>Tipo de comunicaciones: &nbsp; </label><select class="form-control form-control-sm"  v-model="tipocargado" id="tipocargado" >
                <option value="defecto">Envío de mensajes (Defecto)</option>
                <option value="alta-dormidas">Alta de reparaciones y mantenimiento de dormidas</option>
                <option value="repaso">Repaso</option>
                <option value="valoraciones">Introducción de valoraciones</option>
                <option value="cierre">Cierre</option>
                <option value="siniestro">Detalle de siniestro y fotografías</option>
                <option value="autoasignacion">Solicitar servicios</option>
                <option value="fnol">Confirmación de daños del siniestro</option>
                <option value="terceros">Consulta y mantenimiento de terceros</option>
                <option value="fotografias">Fotografías</option>
            </select>
        </div>
    </div>
    
     <div class="row"  style="margin-bottom:10px" v-if="servicio?.compania?.sistema == 'GENERALI'">
        <div class="col-md-6">
            <label>Tipo de comunicaciones: &nbsp; </label><select class="form-control form-control-sm"  v-model="tipocargadogenerali" id="tipocargado" >
                <option value="defecto">Interna</option>
                <option value="sistema_generali">Sistema Generali</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6" v-if="servicio.tramitado == 1 && columna=='col-md-6'">
            <servicio-comunicaciones-form-generali-auxiliar :minimizarprop="minimizarprop" :id="id" v-if="servicio.compania.sistema == 'GENERALI' && tipocargadogenerali == 'defecto'" />
            <servicio-comunicaciones-form-generali :minimizarprop="minimizarprop" :id="id" v-else-if="servicio.compania.sistema == 'GENERALI' && tipocargadogenerali == 'sistema_generali'" />
            <servicio-comunicaciones-form-interparnter :minimizarprop="minimizarprop" :id="id" v-else-if="servicio.compania.sistema == 'IPAS_WS'" />
            <servicio-comunicaciones-form-multiasitencia :minimizarprop="minimizarprop" :servicio="servicio" :tipocargado="tipocargado" :id="id" v-else-if="servicio.compania.sistema == 'MULTIASISTENCIA_WS'" />
            <servicio-comunicaciones-form :id="id" :minimizarprop="minimizarprop" :servicio="servicio" v-else />

        </div>
        <div :class="columna" :style="servicio.tramitado != 1? 'justify-self:start':'justify-self:end'">
            <servicio-comunicaciones-lista ref="listaComu" :columna="columna" :minimizarprop="minimizarprop" :mensajes="mensajes" :id="id" :resumen="resumen"
                @actualizaMensaje="actualizaMensaje" @recargarMensajes="cargarmensajes"/>
        </div>
        <div class="col-md-12" v-if="servicio.tramitado == 1 && columna=='col-md-12'">
            <servicio-comunicaciones-form-generali-auxiliar :minimizarprop="minimizarprop" :id="id" v-if="servicio.compania.sistema == 'GENERALI' && tipocargadogenerali == 'defecto'" />
            <servicio-comunicaciones-form-generali :minimizarprop="minimizarprop" :id="id" v-else-if="servicio.compania.sistema == 'GENERALI ' && tipocargadogenerali == 'sistema_generali'" />
            <servicio-comunicaciones-form-interparnter :minimizarprop="minimizarprop" :id="id" v-else-if="servicio.compania.sistema == 'IPAS_WS'" />
            <servicio-comunicaciones-form-multiasitencia :minimizarprop="minimizarprop" :servicio="servicio" :tipocargado="tipocargado" :id="id" v-else-if="servicio.compania.sistema == 'MULTIASISTENCIA_WS'"/>
            <servicio-comunicaciones-form :minimizarprop="minimizarprop" :id="id" :servicio="servicio" v-else />

        </div>
    </div>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
import serviciocomunicacionesform from './comunicaciones_form.vue';
import serviciocomunicacioneslista from './comunicaciones_lista.vue';
import serviciocomonicacionesformgenerali from './especificas/comunicaciones_form_generali.vue';
import serviciocomunicacionesforminterpartner from './especificas/comunicaciones_form_interpartner.vue';
import serviciocomunicacionesmultiasistencia from './especificas/comunicaciones_form_multiasistencia.vue';
import serviciocomunicacionesformgeneraliauxiliar from './especificas/comunicaciones_form_generali_auxiliar.vue';

export default ({
            props: ['id', 'cargar', 'servicio','visitasinterpwgs','minimizarprop'],
    setup() {
        return;
    },
    components: {
        'servicio-comunicaciones-form': serviciocomunicacionesform,
        'servicio-comunicaciones-lista': serviciocomunicacioneslista,
        'servicio-comunicaciones-form-generali': serviciocomonicacionesformgenerali,
        'servicio-comunicaciones-form-interparnter': serviciocomunicacionesforminterpartner,
        'servicio-comunicaciones-form-multiasitencia':serviciocomunicacionesmultiasistencia,
        'servicio-comunicaciones-form-generali-auxiliar':serviciocomunicacionesformgeneraliauxiliar,
        
    },
      data() {
        return {
            clientedatos: [],
            titulocliente: '',
            mensajes: '',
            tramitado: true,
            columna: "col-md-6",
            tipocargado: 'defecto',
            tipocargadogenerali: 'defecto',
            soporteencontrado:false,
            urlglobal:'',
            activeIndex:0,
            documentosSeleccionados: {},
            descripcionDocumentos: {},
        }
    },
    methods: {
        estaEnviado(visita, idDocumento) {

            if (!visita.documentos_enviados) {
                return false;
            }

            return visita.documentos_enviados.some(
                doc => doc.id_documento === idDocumento
            );
        },
        async actualizaMensaje(id_mensaje) {
            let mensajesaux = [];
            const api = new PwgsApi();
            mensajesaux = await api.get('servicios/' + this.$props.id + '/mensajes');
            mensajesaux = mensajesaux.datos;
            var mensajeencontrado = '';
            mensajesaux.forEach(mensaje => {
                if(mensaje.id_mensaje == id_mensaje){
                    mensajeencontrado = mensaje;
                }
            }) 
            console.log('llegamens');
            if(mensajeencontrado){
                console.log('mensajeencontrado',mensajeencontrado);
                this.$refs.listaComu.cambiaMensaje(mensajeencontrado);
            }
        },
         marcarTodosDocumentos() {

            if (!this.visitasinterpwgs) return;

            this.visitasinterpwgs.forEach(visita => {

                const key =
                    'fotos_interpwgs' +
                    visita.id_comunicacion;

                const keyDescripcion =
                    'fotos_interpwgs_descripcion' +
                    visita.id_comunicacion;

                const ids = (
                    visita.documentos_disponibles || []
                )
                .filter(doc =>
                    !this.estaEnviado(
                        visita,
                        doc.id_documento
                    )
                )
                .map(doc => doc.id_documento);

                this.documentosSeleccionados = {

                    ...this.documentosSeleccionados,

                    [key]: [...ids],

                    [keyDescripcion]: {}

                };

            });

        },
        todosDocumentosSeleccionados(visita) {

            const key =
                'fotos_interpwgs' +
                visita.id_comunicacion;

            const docs = (
                visita.documentos_disponibles || []
            )
            .filter(doc =>
                !this.estaEnviado(
                    visita,
                    doc.id_documento
                )
            );

            const ids =
                docs.map(doc => doc.id_documento);

            const actuales =
                this.documentosSeleccionados[key] || [];

            return (
                ids.length > 0 &&
                ids.every(id =>
                    actuales.includes(id)
                )
            );

        },
toggleTodosDocumentos(visita) {

            const key =
                'fotos_interpwgs' +
                visita.id_comunicacion;

            const keyDescripcion =
                'fotos_interpwgs_descripcion' +
                visita.id_comunicacion;

            const docs = (
                visita.documentos_disponibles || []
            )
            .filter(doc =>
                !this.estaEnviado(
                    visita,
                    doc.id_documento
                )
            );

            const ids =
                docs.map(doc => doc.id_documento);

            const actuales =
                this.documentosSeleccionados[key] || [];

            const todosMarcados =
                ids.length > 0 &&
                ids.every(id =>
                    actuales.includes(id)
                );

            // DESMARCAR
            if (todosMarcados) {

                this.documentosSeleccionados = {

                    ...this.documentosSeleccionados,

                    [key]: [],

                    [keyDescripcion]: {}

                };

                return;
            }

            // MARCAR
            this.documentosSeleccionados = {

                ...this.documentosSeleccionados,

                [key]: [...ids],

                [keyDescripcion]: {}

            };

        },
          getUrl(documento) {

            if (
                this.urlglobal != 'null.pwgs.app'
            ) {

                return documento.url_completa_descarga;

            }

            return (
                "https://192.168.100.147/documentos.php?documento=" +
                documento.documento +
                "&servicio=" +
                documento.servicios_idservicio
            );

        },
        toggleDocumentoDescripcion(visita, documento) {
                const key = 'fotos_interpwgs_descripcion' + visita.id_comunicacion;

            

                if (!this.documentosSeleccionados[key]) {
                    this.documentosSeleccionados[key] = {};
                }

                this.documentosSeleccionados[key][documento.id_documento] =
                    this.descripcionDocumentos[documento.id_documento];

        },
        toggleDocumento(visita, documento, event) {
            const key = 'fotos_interpwgs' + visita.id_comunicacion;
            const key2 = 'fotos_interpwgs_descripcion' + visita.id_comunicacion;

            if (event.target.checked) {

                if (!this.documentosSeleccionados[key]) {
                    this.documentosSeleccionados[key] = [];
                }

                if (!this.documentosSeleccionados[key2]) {
                    this.documentosSeleccionados[key2] = {};
                }

                // añadir id documento
                this.documentosSeleccionados[key].push(documento.id_documento);

                // guardar descripción
                this.documentosSeleccionados[key2][documento.id_documento] =
                    this.descripcionDocumentos[documento.id_documento];

            } else {

                if (this.documentosSeleccionados[key]) {
                    this.documentosSeleccionados[key] =
                        this.documentosSeleccionados[key].filter(
                            id => id !== documento.id_documento
                        );
                }

                if (this.documentosSeleccionados[key2]) {
                    delete this.documentosSeleccionados[key2][documento.id_documento];
                }
            }
        },
        ampliarcolumna() {
        this.columna = "col-md-12";
    },
   
    async enviarinformacionvisita(visita) {

            const subidadatos = {

                id_visita:
                    visita.id_visita,

                id_visita_reparadora:
                    visita.id_comunicacion,

                fotos_interpwgs:
                    this.documentosSeleccionados[
                        'fotos_interpwgs' +
                        visita.id_comunicacion
                    ],

                fotos_interpwgs_descripcion:
                    this.documentosSeleccionados[
                        'fotos_interpwgs_descripcion' +
                        visita.id_comunicacion
                    ],

                en_domicilio: 1,

                realizados:
                    visita.trabajos_realizados_enviar,

                pendientes:
                    visita.trabajos_pendientes_enviar,

                firma:
                    visita.enviarfirma,

                finalizacion:
                    visita.enviarfinalizacion

            };

            try {

                const api = new PwgsApi();

                await api.put(

                    'interpwgs-pwgs/' +
                    this.$props.id +
                    '/enviar-informacion-visita',

                    subidadatos

                );

                this.$toast.add({

                    severity: 'success',
                    summary: 'Enviado',
                    detail: 'Datos de visita enviados',
                    life: 2000

                });

            }
            catch(error) {

                console.log(error);

                this.$toast.add({

                    severity: 'error',
                    summary: 'Error',
                    detail: error,
                    life: 5000

                });

            }

            this.$parent.cargarInterpwgs();

        },
        hayDocumentosSeleccionables(visita) { return ( visita.documentos_disponibles && visita.documentos_disponibles.some( doc => !this.estaEnviado( visita, doc.id_documento ) ) ); },



        reducircolumna() {
            this.columna = "col-md-6";
        },
        async cargarmensajes(tipo) {
            this.mensajes = [];
            if(this.servicio.tramitado!=1){
                this.tramitado = false;
            }else{
                this.tramitado = true;
            }
            //GET  modulos/pwgsapi/index.php/servicios/:id/mensajes
            const api = new PwgsApi();
            let mensajesaux = [];
            if (tipo && tipo != ''){
                try{
                        mensajesaux = await api.get('servicios/' + this.$props.id + '/mensajes?'+tipo);

                }
                catch(error){
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }else{
                try{
                        mensajesaux = await api.get('servicios/' + this.$props.id + '/mensajes');          

                }
                catch(error){
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
            this.mensajes = mensajesaux.datos;
            this.mensajes.forEach(element => {
                element.reducido = true;
            });
        },
       async comprobarpermisos(){
            const api = new PwgsApi();
            let auxusuario = localStorage.getItem('usuario');
            const resppermisos = await api.get('usuarios/'+auxusuario+'/permisos');
            var permisos = resppermisos.datos;
            var encontrado = permisos.find(permiso => permiso.nombre_permiso == "soporte");
         if(encontrado){
                this.soporteencontrado = true;
            }
            console.log("permisos",this.soporteencontrado);
        }
        
    },
    watch: {
        id() {
            this.cargarmensajes();
            this.$parent.mostrarf2();
         },
         cargar(){
            this.cargarmensajes();
            this.$parent.cargarInterpwgs();
         },
          visitasinterpwgs: {

            immediate: true,

            deep: true,

            handler() {

                this.marcarTodosDocumentos();

            }

        }

    },
    computed: {
    visitasUnicas() {
        if (!this.visitasinterpwgs) return [];

        const vistos = new Set();

        return this.visitasinterpwgs.filter(visita => {

            // Campos que definen si dos visitas son "la misma"
            const huella = JSON.stringify({
                id_visita: visita.id_visita,
                fecha_visita: visita.fecha_visita,
                hora_visita: visita.hora_visita,
                especialidad: visita.especialidad,
                anulada: visita.anulada,
                finalizacion: visita.finalizacion,
                en_domicilio: visita.en_domicilio,
                firmada_visita: visita.firmada_visita,
                firma: visita.firma,
                trabajos_realizados_enviar: visita.trabajos_realizados_enviar,
                trabajos_pendientes_enviar: visita.trabajos_pendientes_enviar
            });

            if (vistos.has(huella)) {
                return false; // duplicada, no se muestra
            }

            vistos.add(huella);
            return true;
        });
    }
},
    mounted(){
                this.urlglobal = localStorage.getItem("direccion");

        this.comprobarpermisos();
        setTimeout(async() => {
        this.cargarmensajes();
                    }, 1000); 
        
    },
    activated(){
        this.cargarmensajes();
    }
})



</script>
<style scoped>
.col-checkbox {
    text-align: center;       /* Centra horizontal */
}

.col-checkbox input[type="checkbox"] {
    margin-top: 5px;          /* Ajuste fino vertical */
}
.col-checkbox {
    width: 1%;
    white-space: nowrap;
}
.col-fecha{
    width: 1%;
    white-space: nowrap;
}
.col-fotos{
    width:20%;
}
.contenedor-imagenes{
  display:flex;
  flex-wrap:wrap;
  gap:15px;
}

.doc-item{
  width:120px;
  text-align:center;
}

.img-wrapper{
  position:relative;
}

.miniatura{
  width:50px;
  height:50px;
  object-fit:cover;
  border-radius:6px;
  cursor:pointer;
  border:1px solid #ddd;
}

/* preview grande */
.preview{
  display:none;
  position:absolute;
  top:-10px;
  left:110%;
  z-index:10;
}

.preview img{
  width:600px;
  border:1px solid #ccc;
  background:white;
  padding:4px;
  border-radius:6px;
}

.img-wrapper:hover .preview{
  display:block;
}

.check-doc{
  display:block;
  margin-top:5px;
  font-size:12px;
}
</style>
